import $ from 'jquery'
import axios from 'axios'

const leaveDetails = () => {
    const forms = document.querySelectorAll('form.leave-details__form')
    if (forms.length === 0)
        return

    //const proxy = location.host.includes('local') || location.host.includes('upress') || location.host.includes('vangus') ? 'https://cors-anywhere.herokuapp.com/' : ''//
    const proxy = ''// 'https://cors-anywhere.herokuapp.com/'
    const url = 'http://api.bat-ami.org.il/Api/Home/AddNewContactData'

    forms.forEach(form => {
        form.addEventListener('submit', e => {
            e.preventDefault()

            const fields = {}
            form.querySelectorAll('input').forEach(field => {
                fields[field['name']] = field.value
            })
            console.log(fields)

            axios.post(proxy + url, fields)
                .then(res => {
                    console.log(res)
                    form.innerHTML = `<h3>תגובת השרת: ${res}<h3>`
                })
                .catch(err => {
                    console.log(err)
                    form.innerHTML = `<h3>תגובת השרת: ${err}<h3>`
                })

        })
    })
}
export default leaveDetails